import React from "react"
import { BottomDrawer, Modal } from "@mallardbay/lib-react-components"

import { useIsMobile } from "~utils/hooks/use-is-mobile"
import AppPromptContent, {
    useHasPromptImage,
} from "~components/shared/app-prompts/app-prompt-content"
import type { AppPromptFieldsFragment } from "~graphql/app-prompts.generated"

type Props = {
    readonly prompt: AppPromptFieldsFragment
    readonly onDismiss: () => void
}

export default function AppPromptModal({ prompt, onDismiss }: Props) {
    const isMobile = useIsMobile()
    const hasImage = useHasPromptImage(prompt)
    const modalSize = hasImage ? "lg" : "md"

    const content = <AppPromptContent prompt={prompt} />

    if (isMobile) {
        return (
            <BottomDrawer isOpen onClose={onDismiss}>
                {content}
            </BottomDrawer>
        )
    }

    return (
        <Modal isOpen onClose={onDismiss} size={modalSize}>
            {content}
        </Modal>
    )
}
